import React, { memo } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { trackSettingsInteraction } from 'Pods/ThreeDStudio/Services/studioTracker'
import ToggleSelector from 'Pods/ThreeDStudio/Shared/ToggleSelector/ToggleSelector'
import { setIsSmartLowPoly } from 'Pods/ThreeDStudio/Store/actions/modelSettings'

const handleSmartLowPolyToggle = (isSmartLowPoly) => {
  trackSettingsInteraction('smart_low_poly', isSmartLowPoly)
  setIsSmartLowPoly(isSmartLowPoly)
}

function SmartLowPolySelector() {
  const t = useTranslation()

  return (
    <ToggleSelector
      id="model-settings-smart-low-poly"
      keyName="isSmartLowPoly"
      label={t('leftSide.smartLowPoly.label')}
      setFunction={handleSmartLowPolyToggle}
      sliceName="modelSettings"
    />
  )
}

export default memo(SmartLowPolySelector)
